/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AdministrationUserDetails } from '../models/administration-user-details';
import { AdministrationUsersInformation } from '../models/administration-users-information';
import { Client } from '../models/client';
import { ClientWithRolesAndSites } from '../models/client-with-roles-and-sites';
import { createClient } from '../fn/administration/create-client';
import { CreateClient$Params } from '../fn/administration/create-client';
import { deleteAdministrationOrganizationUserV3 } from '../fn/administration/delete-administration-organization-user-v-3';
import { DeleteAdministrationOrganizationUserV3$Params } from '../fn/administration/delete-administration-organization-user-v-3';
import { getAdministrationOrganizationSiteUsersV3 } from '../fn/administration/get-administration-organization-site-users-v-3';
import { GetAdministrationOrganizationSiteUsersV3$Params } from '../fn/administration/get-administration-organization-site-users-v-3';
import { getAdministrationOrganizationSiteUserV3 } from '../fn/administration/get-administration-organization-site-user-v-3';
import { GetAdministrationOrganizationSiteUserV3$Params } from '../fn/administration/get-administration-organization-site-user-v-3';
import { getAdministrationOrganizationUsersV3 } from '../fn/administration/get-administration-organization-users-v-3';
import { GetAdministrationOrganizationUsersV3$Params } from '../fn/administration/get-administration-organization-users-v-3';
import { getAdministrationOrganizationUserV3 } from '../fn/administration/get-administration-organization-user-v-3';
import { GetAdministrationOrganizationUserV3$Params } from '../fn/administration/get-administration-organization-user-v-3';
import { getClients } from '../fn/administration/get-clients';
import { GetClients$Params } from '../fn/administration/get-clients';
import { postAdministrationOrganizationSitesUserV3 } from '../fn/administration/post-administration-organization-sites-user-v-3';
import { PostAdministrationOrganizationSitesUserV3$Params } from '../fn/administration/post-administration-organization-sites-user-v-3';
import { postAdministrationOrganizationUserV3 } from '../fn/administration/post-administration-organization-user-v-3';
import { PostAdministrationOrganizationUserV3$Params } from '../fn/administration/post-administration-organization-user-v-3';
import { putAdministrationOrganizationSitesUserV3 } from '../fn/administration/put-administration-organization-sites-user-v-3';
import { PutAdministrationOrganizationSitesUserV3$Params } from '../fn/administration/put-administration-organization-sites-user-v-3';
import { putAdministrationOrganizationUserV3 } from '../fn/administration/put-administration-organization-user-v-3';
import { PutAdministrationOrganizationUserV3$Params } from '../fn/administration/put-administration-organization-user-v-3';

@Injectable({ providedIn: 'root' })
export class AdministrationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAdministrationOrganizationUsersV3()` */
  static readonly GetAdministrationOrganizationUsersV3Path = '/administration/organizations/{organizationKey}/users';

  /**
   * Get organization users information.
   *
   * Return all users of an organization. The organization must
   * belong to the calling user.
   * Users Permissions are returned.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAdministrationOrganizationUsersV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdministrationOrganizationUsersV3$Response(params: GetAdministrationOrganizationUsersV3$Params, context?: HttpContext): Observable<StrictHttpResponse<AdministrationUsersInformation>> {
    return getAdministrationOrganizationUsersV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Get organization users information.
   *
   * Return all users of an organization. The organization must
   * belong to the calling user.
   * Users Permissions are returned.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAdministrationOrganizationUsersV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdministrationOrganizationUsersV3(params: GetAdministrationOrganizationUsersV3$Params, context?: HttpContext): Observable<AdministrationUsersInformation> {
    return this.getAdministrationOrganizationUsersV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdministrationUsersInformation>): AdministrationUsersInformation => r.body)
    );
  }

  /** Path part for operation `postAdministrationOrganizationUserV3()` */
  static readonly PostAdministrationOrganizationUserV3Path = '/administration/organizations/{organizationKey}/users';

  /**
   * Create new user.
   *
   * Create a new user and add this user to the organization and the given organization sites
   * and equip the new user with permissions according to the given roles.
   * The requesting user must have access to the organization the new user is added.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAdministrationOrganizationUserV3()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postAdministrationOrganizationUserV3$Response(params: PostAdministrationOrganizationUserV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postAdministrationOrganizationUserV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Create new user.
   *
   * Create a new user and add this user to the organization and the given organization sites
   * and equip the new user with permissions according to the given roles.
   * The requesting user must have access to the organization the new user is added.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAdministrationOrganizationUserV3$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postAdministrationOrganizationUserV3(params: PostAdministrationOrganizationUserV3$Params, context?: HttpContext): Observable<void> {
    return this.postAdministrationOrganizationUserV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAdministrationOrganizationUserV3()` */
  static readonly GetAdministrationOrganizationUserV3Path = '/administration/organizations/{organizationKey}/users/{userKey}';

  /**
   * Get information details for one organization user.
   *
   * Return one user of an organization. The organization must
   * belong to the calling user.
   * Users, Org and Sites Permissions are returned.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAdministrationOrganizationUserV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdministrationOrganizationUserV3$Response(params: GetAdministrationOrganizationUserV3$Params, context?: HttpContext): Observable<StrictHttpResponse<AdministrationUserDetails>> {
    return getAdministrationOrganizationUserV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Get information details for one organization user.
   *
   * Return one user of an organization. The organization must
   * belong to the calling user.
   * Users, Org and Sites Permissions are returned.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAdministrationOrganizationUserV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdministrationOrganizationUserV3(params: GetAdministrationOrganizationUserV3$Params, context?: HttpContext): Observable<AdministrationUserDetails> {
    return this.getAdministrationOrganizationUserV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdministrationUserDetails>): AdministrationUserDetails => r.body)
    );
  }

  /** Path part for operation `putAdministrationOrganizationUserV3()` */
  static readonly PutAdministrationOrganizationUserV3Path = '/administration/organizations/{organizationKey}/users/{userKey}';

  /**
   * Edit user with new site roles/permissions (v3).
   *
   * Edit an existing user and add this user to the given organization sites
   * and equip the new user with permissions according to the given roles.
   * The requesting user must have access to the organization the user is added.
   * All previously set permissions and linked sites are removed.
   * All sites and roles to be set must be passed.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putAdministrationOrganizationUserV3()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putAdministrationOrganizationUserV3$Response(params: PutAdministrationOrganizationUserV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return putAdministrationOrganizationUserV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Edit user with new site roles/permissions (v3).
   *
   * Edit an existing user and add this user to the given organization sites
   * and equip the new user with permissions according to the given roles.
   * The requesting user must have access to the organization the user is added.
   * All previously set permissions and linked sites are removed.
   * All sites and roles to be set must be passed.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putAdministrationOrganizationUserV3$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putAdministrationOrganizationUserV3(params: PutAdministrationOrganizationUserV3$Params, context?: HttpContext): Observable<void> {
    return this.putAdministrationOrganizationUserV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteAdministrationOrganizationUserV3()` */
  static readonly DeleteAdministrationOrganizationUserV3Path = '/administration/organizations/{organizationKey}/users/{userKey}';

  /**
   * Delete a user from the organization.
   *
   * Deletes the specified user from Keycloak and the organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAdministrationOrganizationUserV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAdministrationOrganizationUserV3$Response(params: DeleteAdministrationOrganizationUserV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAdministrationOrganizationUserV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a user from the organization.
   *
   * Deletes the specified user from Keycloak and the organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAdministrationOrganizationUserV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAdministrationOrganizationUserV3(params: DeleteAdministrationOrganizationUserV3$Params, context?: HttpContext): Observable<void> {
    return this.deleteAdministrationOrganizationUserV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAdministrationOrganizationSiteUsersV3()` */
  static readonly GetAdministrationOrganizationSiteUsersV3Path = '/administration/organization-sites/{organizationSiteKey}/users';

  /**
   * Get all users with roles of a orgnaization site.
   *
   * Get all assigned users from organization site with
   * all roles for the organization site.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAdministrationOrganizationSiteUsersV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdministrationOrganizationSiteUsersV3$Response(params: GetAdministrationOrganizationSiteUsersV3$Params, context?: HttpContext): Observable<StrictHttpResponse<AdministrationUsersInformation>> {
    return getAdministrationOrganizationSiteUsersV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all users with roles of a orgnaization site.
   *
   * Get all assigned users from organization site with
   * all roles for the organization site.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAdministrationOrganizationSiteUsersV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdministrationOrganizationSiteUsersV3(params: GetAdministrationOrganizationSiteUsersV3$Params, context?: HttpContext): Observable<AdministrationUsersInformation> {
    return this.getAdministrationOrganizationSiteUsersV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdministrationUsersInformation>): AdministrationUsersInformation => r.body)
    );
  }

  /** Path part for operation `getAdministrationOrganizationSiteUserV3()` */
  static readonly GetAdministrationOrganizationSiteUserV3Path = '/administration/organization-sites/{organizationSiteKey}/users/{userKey}';

  /**
   * Get information details for one organization site user.
   *
   * Return one user of an organization site. The organization site must
   * belong to the calling user.
   * Permissions are returned.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAdministrationOrganizationSiteUserV3()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdministrationOrganizationSiteUserV3$Response(params: GetAdministrationOrganizationSiteUserV3$Params, context?: HttpContext): Observable<StrictHttpResponse<AdministrationUserDetails>> {
    return getAdministrationOrganizationSiteUserV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Get information details for one organization site user.
   *
   * Return one user of an organization site. The organization site must
   * belong to the calling user.
   * Permissions are returned.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAdministrationOrganizationSiteUserV3$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAdministrationOrganizationSiteUserV3(params: GetAdministrationOrganizationSiteUserV3$Params, context?: HttpContext): Observable<AdministrationUserDetails> {
    return this.getAdministrationOrganizationSiteUserV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdministrationUserDetails>): AdministrationUserDetails => r.body)
    );
  }

  /** Path part for operation `postAdministrationOrganizationSitesUserV3()` */
  static readonly PostAdministrationOrganizationSitesUserV3Path = '/administration/organization-sites/users';

  /**
   * Create new user for organization sites.
   *
   * Create a new user and add this user to the organization for the specified organization sites
   * and equip the new user with the rights according to the specified roles.
   * The requesting user must have access to the organization sites to which the new user is to be added.
   * The new user can have only the roles carrier, consignee, consignor, site_admin.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAdministrationOrganizationSitesUserV3()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postAdministrationOrganizationSitesUserV3$Response(params: PostAdministrationOrganizationSitesUserV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postAdministrationOrganizationSitesUserV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Create new user for organization sites.
   *
   * Create a new user and add this user to the organization for the specified organization sites
   * and equip the new user with the rights according to the specified roles.
   * The requesting user must have access to the organization sites to which the new user is to be added.
   * The new user can have only the roles carrier, consignee, consignor, site_admin.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAdministrationOrganizationSitesUserV3$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postAdministrationOrganizationSitesUserV3(params: PostAdministrationOrganizationSitesUserV3$Params, context?: HttpContext): Observable<void> {
    return this.postAdministrationOrganizationSitesUserV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `putAdministrationOrganizationSitesUserV3()` */
  static readonly PutAdministrationOrganizationSitesUserV3Path = '/administration/organization-sites/users/{userKey}';

  /**
   * Edit user with new site roles/permissions (v3).
   *
   * Edit an existing user and add this user to the given organization sites
   * and equip the new user with permissions according to the given roles.
   * The requesting user must have access to the organization sites the user is added.
   * All previously set permissions and linked sites are removed.
   * All sites and roles to be set must be passed.
   * The optional submitted password is ignored.
   * The user can have only the roles carrier, consignee, consignor, site_admin.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putAdministrationOrganizationSitesUserV3()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putAdministrationOrganizationSitesUserV3$Response(params: PutAdministrationOrganizationSitesUserV3$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return putAdministrationOrganizationSitesUserV3(this.http, this.rootUrl, params, context);
  }

  /**
   * Edit user with new site roles/permissions (v3).
   *
   * Edit an existing user and add this user to the given organization sites
   * and equip the new user with permissions according to the given roles.
   * The requesting user must have access to the organization sites the user is added.
   * All previously set permissions and linked sites are removed.
   * All sites and roles to be set must be passed.
   * The optional submitted password is ignored.
   * The user can have only the roles carrier, consignee, consignor, site_admin.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putAdministrationOrganizationSitesUserV3$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putAdministrationOrganizationSitesUserV3(params: PutAdministrationOrganizationSitesUserV3$Params, context?: HttpContext): Observable<void> {
    return this.putAdministrationOrganizationSitesUserV3$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getClients()` */
  static readonly GetClientsPath = '/administration/organizations/{organizationKey}/clients';

  /**
   * retrieves a list of API clients.
   *
   * Retrieves a list of API clients for the organization.
   * The requesting user must have access to the organization the API clients belong to.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClients()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClients$Response(params: GetClients$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientWithRolesAndSites>>> {
    return getClients(this.http, this.rootUrl, params, context);
  }

  /**
   * retrieves a list of API clients.
   *
   * Retrieves a list of API clients for the organization.
   * The requesting user must have access to the organization the API clients belong to.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getClients$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClients(params: GetClients$Params, context?: HttpContext): Observable<Array<ClientWithRolesAndSites>> {
    return this.getClients$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ClientWithRolesAndSites>>): Array<ClientWithRolesAndSites> => r.body)
    );
  }

  /** Path part for operation `createClient()` */
  static readonly CreateClientPath = '/administration/organizations/{organizationKey}/clients';

  /**
   * creates a new API client.
   *
   * Creates a new API client for the organization and the given organization sites.
   * The requesting user must have access to the organization the API client belongs to.
   * By creating an api client you agree that this api client is only used in accordance with the terms of service of this application.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createClient()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createClient$Response(params: CreateClient$Params, context?: HttpContext): Observable<StrictHttpResponse<Client>> {
    return createClient(this.http, this.rootUrl, params, context);
  }

  /**
   * creates a new API client.
   *
   * Creates a new API client for the organization and the given organization sites.
   * The requesting user must have access to the organization the API client belongs to.
   * By creating an api client you agree that this api client is only used in accordance with the terms of service of this application.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createClient$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createClient(params: CreateClient$Params, context?: HttpContext): Observable<Client> {
    return this.createClient$Response(params, context).pipe(
      map((r: StrictHttpResponse<Client>): Client => r.body)
    );
  }

}
